const en = {
  "menu.staff_meal": "Meal Control",
};

export default en;
